// extracted by mini-css-extract-plugin
var _1 = "FttZAlQLtao2EdRrsHcZ";
var _2 = "UUXuhHTcm_I2rq8Y1IsV";
var _3 = "UPD_5Ll4Wrq_l80x6yKQ";
var _4 = "rO4PtEc_VCqgIzGmoOOU";
export { _1 as "container", _2 as "storybook", _3 as "tiles", _4 as "wallpaper" }
